import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="sastra-site-footer">
      <div className="sastra-ft-container">
        
        <div className="sastra-ft-col sastra-ft-about">
          <div className="sastra-ft-logo">
            <i className="fas fa-solar-panel"></i>
            <h2>Sastra Energy</h2>
          </div>
          <p>Experts en solutions photovoltaïques depuis 2016. Nous offrons des solutions énergétiques renouvelables de haute qualité pour tous vos besoins.</p>
          
          <div className="sastra-ft-actions">
            <div className="sastra-ft-action-item">
              <i className="far fa-envelope"></i><span>Mail</span>
            </div>
            <div className="sastra-ft-action-item">
              <i className="fas fa-phone-alt"></i><span>Téléphone</span>
            </div>
            <div className="sastra-ft-action-item">
              <i className="fas fa-map-marker-alt"></i><span>Localisation</span>
            </div>
          </div>
        </div>

        <div className="sastra-ft-col sastra-ft-services">
          <h3>Nos Services</h3>
          <ul className="sastra-ft-list">
            <li><i className="fas fa-solar-panel"></i> Solaire PV Réseau BT</li>
            <li><i className="fas fa-solar-panel"></i> Solaire PV Réseau MT</li>
            <li><i className="fas fa-water"></i> Pompage Solaire</li>
            <li><i className="fas fa-home"></i> Sites Isolés</li>
            <li><i className="fas fa-tools"></i> Maintenance & Réparation</li>
          </ul>
        </div>

        <div className="sastra-ft-col sastra-ft-bureaux">
          <h3>Nos Bureaux</h3>
          <ul className="sastra-ft-list">
            <li><i className="fas fa-map-marker-alt"></i> Le Bardo</li>
            <li><i className="fas fa-map-marker-alt"></i> Béja</li>
            <li><i className="fas fa-map-marker-alt"></i> Hammamet</li>
            <li><i className="fas fa-map-marker-alt"></i> Sousse</li>
          </ul>
        </div>

        <div className="sastra-ft-col">
          <h3>Contact Principal</h3>
          <div className="sastra-ft-contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <div>Résidence MAAROUFI, AV Habib<br />Bourguiba, Bardo 2000</div>
          </div>
          <div className="sastra-ft-contact-item">
            <i className="fas fa-phone-alt"></i>
            <div>+216 36 437 473<br />+216 93 454 400</div>
          </div>
          <div className="sastra-ft-contact-item">
            <i className="far fa-envelope"></i>
            <div>info@sastraenergy.com</div>
          </div>

          <div className="sastra-ft-socials">
            <a href="#" className="s-in" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="s-fb" title="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="s-ig" title="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="#" className="s-yt" title="YouTube"><i className="fab fa-youtube"></i></a>
            <a href="#" className="s-tw" title="X (Twitter)"><i className="fab fa-twitter"></i></a>
          </div>
        </div>

      </div>

      <div className="sastra-ft-bottom">
        <div className="sastra-ft-bottom-inner">
          <div>© 2026 Sastra Energy. Tous droits réservés.</div>
          <div className="sastra-ft-links">
            <a href="#">Politique de confidentialité</a>
            <span>|</span>
            <a href="#">Conditions d'utilisation</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;